import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import messages from '../../messages';
import { renderPasswordCriteria } from './renderers';
import styles from './Password.pcss';
const PasswordPartial = ({ id, formValues, labelMessage, isOneLiner = false, onChange })=>{
    useStyles(styles);
    const isEmptyValue = !(formValues && formValues.values && formValues.values[id]);
    const renderErrors = (errors)=>renderPasswordCriteria(errors, isEmptyValue);
    return /*#__PURE__*/ _jsx(FormGroup, {
        id: id,
        labelMessage: labelMessage,
        formValues: formValues,
        isOneLiner: isOneLiner,
        renderErrors: renderErrors,
        className: styles.root,
        children: /*#__PURE__*/ _jsx(Input, {
            type: "password",
            placeholder: messages.placeholders.password,
            attributes: {
                autoComplete: 'new-password'
            },
            onChange: onChange
        })
    });
};
export default PasswordPartial;
